'use strict';

var App = require('app');
var AbstractFormView = require('components/common/views/abstract_form_view');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var RemoteValueTransfer = require('models/rule').RemoteValueTransfer;
var Notification = require('utils/notification');

var SmartTempDialogView = AbstractFormView.extend({
    template: require('components/devices/templates/controller/smart_temp_dialog'),

    ui: {
        isDryRun: '#is-dry-run',
        btnWrite: '#js-save',
        btnStop: '#js-stop',
    },

    events: {
        'mousedown @ui.notEditable': 'cancelEvent',
        'change #is-dry-run': 'toggleDryRun',
        'click @ui.btnWrite': 'validateForm',
        'click @ui.btnStop': 'stopProcedure',
    },

    initialize: function (options) {
        this.options = options;
        this.controllerID = options.controllerID;
        this.meterID = options.meterID;
        this.meterName = options.meterName;
        this.smartTemp = options.smartTempInfo;
        this.circuits = options.circuits;
        this.circuitNames = options.circuitNames;
        this.rvtValues = options.rvtValues;
        this.rvtActive = this.rvtValues && this.rvtValues.length > 0;
        this.isActive = this.smartTemp.getActiveMeterIDs(false).includes(this.meterID);
        this.isDryRun = this.smartTemp.isDryRun() && this.smartTemp.getActiveMeterIDs(true).includes(this.meterID);
    },

    serializeData: function () {
        var data = {};
        var self = this;
        data.smartTemp = this.isActive || this.isDryRun;
        data.isActive = this.isActive;
        data.isDryRun = this.isDryRun;
        data.meterName = this.meterName;
        data.rvtActive = this.rvtActive;
        data.circuits = JSON.parse(JSON.stringify(this.circuits || ''));
        _.each(data.circuits, function (element, idx) {
            data.circuits[idx] = self.circuitNames[element] || element;
        });
        data.title = this.isActive
            ? i18n.TR('Smart Temp aktiv')
            : this.isDryRun
              ? i18n.TR('Smart Temp-Vorschau aktiv')
              : i18n.TR('Smart Temp');
        return data;
    },

    cancelEvent: function (e) {
        e.preventDefault();
        return false;
    },

    toggleDryRun: function () {
        this.isDryRun = !this.isDryRun;
        // show correct warning message
        if (this.isDryRun === true) {
            $('#js-preview-info').removeClass('hidden');
            $('.js-activation-warning').addClass('hidden');
            if (this.smartTemp.isDryRun(true)) {
                $('#js-save').addClass('disabled');
            }
        } else {
            $('#js-preview-info').addClass('hidden');
            $('.js-activation-warning').removeClass('hidden');
            $('#js-save').removeClass('disabled');
        }
    },

    validateForm: function (e) {
        e.preventDefault();
        if (!this.allFieldsValid()) {
            return;
        }

        if (this.options.saveCallback) {
            this.options.saveCallback();
        }
        var cb = this.getOption('callback');
        var self = this;

        if (!this.isDryRun) {
            var allStopped = this.stopRemoteValueTranfer();
            if (!allStopped) {
                return; // some error happened
            }
        }

        this.smartTemp.activate(this.meterID, this.circuits, this.isDryRun, {
            success: function () {
                App.hideModal();
                Notification.show(
                    'success',
                    i18n.TR('Erfolg'),
                    self.isDryRun ? i18n.TR('Smart Temp-Vorschau aktiviert.') : i18n.TR('Smart Temp aktiviert.')
                );
                cb ? cb() : Backbone.history.loadUrl(Backbone.history.fragment);
            },
            error: function (errors) {
                Decorator.enableElement('.modal-dialog');
                App.hideModal();
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Befehl konnte nicht ausgeführt werden.'));
            },
        });
    },

    stopRemoteValueTranfer: function () {
        var self = this;
        var allStopped = true;
        _.each(this.rvtValues, function (value) {
            var rvt = new RemoteValueTransfer({ device_id: self.controllerID, id: value.getAddress() });
            rvt.destroy({
                success: function () {
                    Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Fremdwertbezug beendet.'));
                },
                error: function () {
                    allStopped = false;
                    Notification.show(
                        'error',
                        i18n.TR('Fehler'),
                        i18n.TR('Fremdwertbezug konnte nicht beendet werden.')
                    );
                },
            });
        });
        return allStopped;
    },

    stopProcedure: function () {
        this.stopSmartTemp(this.isDryRun);
        return;
    },

    stopSmartTemp: function (isDryRun) {
        this.smartTemp.deactivate(this.meterID, {
            success: function () {
                App.hideModal();
                Notification.show(
                    'success',
                    i18n.TR('Erfolg'),
                    isDryRun ? i18n.TR('Smart Temp-Vorschau deaktiviert.') : i18n.TR('Smart Temp deaktiviert.')
                );
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
            error: function (errors) {
                Decorator.enableElement('.modal-dialog');
                App.hideModal();
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Befehl konnte nicht ausgeführt werden.'));
            },
        });
    },
});

module.exports = SmartTempDialogView;
